// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const de: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'So wird gespielt',
  'howto.pieces.heading': 'Die Teile',
  'howto.pieces.source': 'Quelle',
  'howto.pieces.mirror': 'Spiegel',
  'howto.pieces.switch': 'Schalter',
  'howto.pieces.exit': 'Ausgang',
  'howto.pieces.wall': 'Wand',
  'howto.controls.heading': 'Die Steuerung',
  'howto.controls.clickSlot.line1': 'Klicke ein Feld an',
  'howto.controls.clickSlot.line2': 'Spiegel setzen',
  'howto.controls.dragMirror.line1': 'Ziehe den Spiegel',
  'howto.controls.dragMirror.line2': 'drehen',
  'howto.controls.rightClick.line1': 'Rechtsklick',
  'howto.controls.rightClick.line2': 'Spiegel entfernen',
  'howto.controls.hint': 'Mausrad: Feinrotation um 1°.   Spiegel antippen: Drehung um 15°.',
  'howto.objective.line1': 'Beleuchte jeden Schalter — das Ausgangsschloss springt auf.',
  'howto.objective.line2':
    'Dann klicke auf den Ausgang. Löse es mit so wenigen Spiegeln wie möglich.',

  'howtoColor.title': 'Farbe und Prismen',
  'howtoColor.pieces.heading': 'Neue Teile',
  'howtoColor.pieces.prism': 'Prisma',
  'howtoColor.pieces.redSwitch': 'Roter Schalter',
  'howtoColor.pieces.yellowSwitch': 'Gelber Schalter',
  'howtoColor.pieces.whiteSwitch': 'Weißer Schalter',
  'howtoColor.how.heading': 'So funktionieren sie',
  'howtoColor.how.line1': 'Ein weißer Strahl trägt rotes, grünes und blaues Licht zugleich.',
  'howtoColor.how.line2':
    'Ein Prisma teilt weißes Licht entlang seiner drei Seiten in drei farbige Strahlen.',
  'howtoColor.how.line3': 'Klicke ein gesetztes Prisma an, um seine Eingangsseite zu drehen.',
  'howtoColor.switches.line1':
    'Schalter zeigen farbige Punkte — das ist die Farbe, die sie verlangen.',
  'howtoColor.switches.line2':
    'Ein gelber Schalter (rote + grüne Punkte) braucht beide Farben gleichzeitig.',
  'howtoColor.switches.line3':
    'Ein weißer Schalter (alle drei) braucht Rot, Grün UND Blau gleichzeitig.',

  'options.hints.label': 'Hinweis-Winkel in Rätseln anzeigen',
  'options.hints.help':
    'Zeigt den Winkel zwischen einfallendem und reflektiertem Strahl bei jedem Aufprall an.',

  'level.01-intro.title': 'Hallo, Licht',
  'level.02-two-mirrors.title': 'Zwei Wenden',
  'level.03-corner.title': 'Wand im Weg',
  'level.04-two-targets.title': 'Zwei Ziele',
  'level.05-tight.title': 'Eng',
  'level.06-hello-color.title': 'Hallo, Farbe',
  'level.07-pick-a-side.title': 'Wähle eine Seite',
  'level.08-yellow.title': 'Gelb',
  'level.09-magenta.title': 'Magenta',
  'level.10-spectrum.title': 'Spektrum',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'rechter',
  'puzzle.hint.angleType.acute': 'spitzer',
  'puzzle.hint.angleType.obtuse': 'stumpfer',
  'puzzle.hint.label': '{angle}°\n{type}',
};
